<template>
  <v-expansion-panels>
    <v-expansion-panel>
      <v-expansion-panel-header>
        <div class="collapsable-header">
          <div class="bold mb">E-Mail Alarme</div>
          <div class="">
            Richte Alarme ein, um über neue Ideen benachrichtigt zu werden.
          </div>
        </div>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <div class="settings-collapsable-inner">
          <div class="settings-collapsable-left">
            <div class="input-text-wrapper no-m">
              <v-switch
                v-model="notification"
                :label="`Alarme erlauben?`"
              ></v-switch>
            </div>
          </div>
          <div class="settings-collapsable-right"></div>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
export default {
  props: ["current"],
  data() {
    return {
      notification: this.current === 1 ? true : false,
      errorMessage: null,
      successMessage: null,
    };
  },
  watch: {
    notification: function () {
      this.changeNotification();
    },
  },
  methods: {
    changeNotification() {
      axios
        .post("/changeNotification", {
          notification: this.notification,
        })
        .then((res) => {})
        .catch((error) => {});
    },
  },
  mounted() {},
  created() {},
  computed: {},
};
</script>

<style>
</style>
